// src/paginas/Reportes/SalidaReportes.jsx
import { useEffect, useState } from "react";
import "../../paginas/Reportes/reportes.css";
import Calendario from "../../ComponentesGlobales/Calendario.jsx";
import { useStoreReportes } from "../../paginas/Reportes/useStoreReportes.js";
import { ProgressSpinner } from "primereact/progressspinner";
import { Chart } from "primereact/chart";
import { enumReporteSeleccionado } from "../FuncionesLocales.js";
import { useStoreHome } from "../../paginas/Home/useStoreHome.js";


export default function SalidaReportes() {
  const FechaDesde = useStoreReportes((s) => s.FechaDesde);
  const FechaHasta = useStoreReportes((s) => s.FechaHasta);
  const BuscandoBarras = useStoreReportes((s) => s.BuscandoEntradasSalidas);
  const ListaBarras = useStoreReportes((s) => s.ListaSalidas);
  const TipoProducto = useStoreReportes((s) => s.TipoProducto);

  const [chartsByUnit, setChartsByUnit] = useState({});
  const [fallbackChart, setFallbackChart] = useState({ data: {}, options: {} });

  const [piesByUnit, setPiesByUnit] = useState({});


  useEffect(() => {
    useStoreHome.setState({ ReportesSeleccionado: enumReporteSeleccionado.PRODUCCION });
    useStoreReportes.setState({ LoteProduccion: '' });
  }, []);
  useEffect(() => {
    useStoreReportes.getState().getEntradasSalidas();
  }, [FechaDesde, FechaHasta, TipoProducto]);

  useEffect(() => {
    const textColor = "black";
    const textColorSecondary = "black";
    const surfaceBorder = getComputedStyle(document.documentElement).getPropertyValue("--surface-border");

    if (!ListaBarras || ListaBarras.length === 0) {
      // Fallback sin datos
      const data = {
        labels: ["Sin datos"],
        datasets: [

          { label: "Medida", backgroundColor: "#d090d6ff", borderColor: "#888888ff", data: [0] },
        ],
      };
      const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: { legend: { labels: { color: textColor } } },
        scales: {
          x: {
            ticks: { color: textColorSecondary, font: { weight: 500 }, maxRotation: 90, minRotation: 0 },
            grid: { display: true, drawBorder: true },
          },
          y: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder, drawBorder: false } },
        },
      };
      setChartsByUnit({});
      setFallbackChart({ data, options });
      return;
    }

    // Agrupar por unidad
    const grouped = ListaBarras.reduce((acc, it) => {
      const unidad = it.UnidadDescripcion || "Sin unidad";
      (acc[unidad] ??= []).push(it);
      return acc;
    }, {});

    // Construir config por unidad
    const palette = [

      "#00DC01",
      "#00B803",
      "#00A704",
      "#009504",
      "#008405",
      "#007206",
      "#006007",
      "#004F07",
      "#003D08"
    ];
    

    const perUnit = {};
    Object.keys(grouped).forEach((unidad) => {
      const unitData = grouped[unidad];

      
      const agregados = unitData.reduce((acc, it) => {
        const raw = it.MercaderiaDescripcion || "Sin descripción";
        const key = raw.trim().toLowerCase();
        if (!acc[key]) acc[key] = { label: raw, peso: 0, unidades: 0 };
        acc[key].peso += Number(it.nPesoOriginal || 0);
        acc[key].unidades += Number(it.nUnidades || 0);
        return acc;
      }, {});

      
      const orden = Object.values(agregados).sort((a, b) => b.peso - a.peso);

      
      const labels = orden.map(o => o.label);
      const medida = orden.map(o => o.peso);
      perUnit[unidad] = {
        data: {
          labels,
          datasets: [
            
            { label: unidad, backgroundColor: palette.slice(0, labels.length), borderColor: palette.slice(0, labels.length), data: medida },
          ],
        },
        options: {
          maintainAspectRatio: false,
          aspectRatio: 0.8,
          plugins: {
            legend: { labels: { color: "black" } },
            title: { display: true, text: `Salidas - ${unidad}`, color: "black", font: { size: 20, weight: "bold" } },
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  const v = Number(ctx.parsed.y) || 0;
                  const unidadTxt = (unidad === "Sin unidad") ? "" : ` ${unidad}`;
                  return ` ${v.toLocaleString("es-AR", { maximumFractionDigits: 2 })}${unidadTxt}`;
                }
              }
            }
          },
          scales: {
            x: {
              ticks: { color: "black", font: { weight: 500 }, maxRotation: 90, minRotation: 0 },
              grid: { display: true, drawBorder: true },
            },
            y: {
              ticks: { color: "black" },
              grid: { color: getComputedStyle(document.documentElement).getPropertyValue("--surface-border"), drawBorder: false },
            },
          },
        },
        raw: unitData,
      };
    });

    setChartsByUnit(perUnit);
  }, [ListaBarras]);

  useEffect(() => {
    if (!ListaBarras || ListaBarras.length === 0) {
      setPiesByUnit({});
      return;
    }

    // agrupar por unidad
    const byUnit = ListaBarras.reduce((acc, it) => {
      const unidad = it.UnidadDescripcion || "Sin unidad";
      (acc[unidad] ||= []).push(it);
      return acc;
    }, {});

    // paleta (teal que venís usando)
    const PALETTE = [

      "#00DC01",
      "#00B803",
      "#00A704",
      "#009504",
      "#008405",
      "#007206",
      "#006007",
      "#004F07",
      "#003D08"
    ];

    const result = {};
    Object.keys(byUnit).forEach((unidad) => {
      const arr = byUnit[unidad];

      // sumar peso por descripción
      const map = arr.reduce((acc, it) => {
        const label = it.MercaderiaDescripcion || "Sin descripción";
        acc[label] = (acc[label] || 0) + Number(it.nPesoOriginal || 0);
        return acc;
      }, {});

      const labels = Object.keys(map);
      const values = labels.map(l => map[l]);

      result[unidad] = {
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: PALETTE,
            borderColor: "#FFFFFF",
            borderWidth: 2
          }]
        },
        options: {
          plugins: {
            legend: {
              position: "bottom",
              labels: { color: "black", usePointStyle: true, padding: 15, font: { size: 11 } }
            },
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  const v = Number(ctx.parsed) || 0;
                  const total = ctx.dataset.data.reduce((a, b) => a + Number(b || 0), 0);
                  const pct = total ? ((v / total) * 100).toFixed(1) : 0;
                  const unidadTxt = (unidad === "Sin unidad") ? "" : ` ${unidad}`;
                  return ` ${v.toLocaleString("es-AR", { maximumFractionDigits: 2 })}${unidadTxt} (${pct}%)`;
                }
              }
            }
          },
          maintainAspectRatio: false
        }
      };
    });

    setPiesByUnit(result);
  }, [ListaBarras]);

  
  
  return (
    <>
      

      <div className="reportes-container">
        <h3 className="subtitulo-reportes" style={{ color: '#1f6842ff'}}>Salidas</h3>

      <div className="filtros-fecha" >
        <div>
          <span style={{ marginTop: 10 }}>Desde: </span>
          <Calendario Fecha={FechaDesde} setFecha={(f) => useStoreReportes.setState({ FechaDesde: f })} />
        </div>
        <div>
          <span style={{ marginTop: 10 }}>Hasta:</span>
          <Calendario Fecha={FechaHasta} setFecha={(f) => useStoreReportes.setState({ FechaHasta: f })} />
        </div>
      </div>
      
        <div className="graficos-reportes">
          {BuscandoBarras ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 400 }}>
              <ProgressSpinner style={{ width: 50, height: 50 }} strokeWidth="8" />
            </div>
          ) : Object.keys(chartsByUnit).length > 0 ? (
            Object.keys(chartsByUnit).map((unidad, idx) => {
              const unit = chartsByUnit[unidad];
              const unitData = unit.raw || [];

              const totalMedida = unitData.reduce((a, c) => a + Number(c.nPesoOriginal || 0), 0);




              return (
                <div key={`salidas-${unidad}-${idx}`} style={{ marginBottom: 30, display: 'flex', justifyContent: 'center' }}>
                  {/* <h4 className="titulo-bloque">Salidas por {unidad}</h4> */}

                  
                  <div className="fila-reportes"  >
                    {/* Barras */}
                    <div className="charts-row"
                      style={{
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'start',
                        justifyContent: 'center',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        paddingBottom: '10px',
                        width: '100%',
                        height: '400px'
                      }}>
                      <Chart type="bar" data={unit.data} options={unit.options} style={{ height: 400, padding: 5 }} />
                    </div>

                    {/* Totales */}
                    <div className="circulos-wrapper" style={{ marginTop: 50 }}>
                      <div className="circle-container">
                        <div className="circle-content">
                          <div className="circle-number">{parseFloat(Number(totalMedida).toFixed(2))}</div>
                          <div className="circle-label">Total {unidad === "Sin unidad" ? "Medida" : unidad}</div>
                        </div>
                      </div>

                    </div>

                    {/* Torta  */}
                    <div className="grafico-torta">
                      <h4 className="titulo-bloque" style={{ textAlign: "center" }}>Distribución por Producto</h4>
                      {piesByUnit[unidad] ? (
                        <Chart
                          type="pie"
                          data={piesByUnit[unidad].data}
                          options={piesByUnit[unidad].options}
                          style={{ height: "300px", width: "100%", padding: "5px" }}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="card">
              <Chart
                type="bar"
                data={fallbackChart.data}
                options={fallbackChart.options}
                style={{ height: "300px", padding: "5px" }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
